import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateNewProfile } from './use-create-new-profile';
export const useCreateNewProfileUseCase = () => {
  const $ = _c(5);
  const navigate = useNavigate();
  const {
    createNewProfile
  } = useCreateNewProfile();
  let t0;
  if ($[0] !== createNewProfile || $[1] !== navigate) {
    t0 = (brand, model) => {
      createNewProfile(brand, model, () => {
        navigate("/piano");
      });
    };
    $[0] = createNewProfile;
    $[1] = navigate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleCreateNewProfile = t0;
  let t1;
  if ($[3] !== handleCreateNewProfile) {
    t1 = {
      handleCreateNewProfile
    };
    $[3] = handleCreateNewProfile;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};